// src/stores/kpi/kpiThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';

export const defectRateThunk = createAsyncThunk(
  'kpi/percentage/defectRate',
  async (params, { extra, rejectWithValue }) => {
    try { return await extra.KPIService.percentage.defectRate(params); }
    catch (err) { return rejectWithValue(err?.response?.data || err.message); }
  }
);

export const deliveryComplianceRateThunk = createAsyncThunk(
  'kpi/percentage/deliveryComplianceRate',
  async (params, { extra, rejectWithValue }) => {
    try { return await extra.KPIService.percentage.deliveryComplianceRate(params); }
    catch (err) { return rejectWithValue(err?.response?.data || err.message); }
  }
);

export const deliveryComplianceThunk = createAsyncThunk(
  'kpi/percentage/deliveryCompliance',
  async (params, { extra, rejectWithValue }) => {
    try { return await extra.KPIService.percentage.deliveryCompliance(params); }
    catch (err) { return rejectWithValue(err?.response?.data || err.message); }
  }
);

export const operationRateThunk = createAsyncThunk(
  'kpi/timeseries/operationRate',
  async (params, { extra, rejectWithValue }) => {
    try { return await extra.KPIService.TimeSeries.operationRate(params); }
    catch (err) { return rejectWithValue(err?.response?.data || err.message); }
  }
);

export const productionByProductThunk = createAsyncThunk(
  'kpi/timeseries/productionByProduct',
  async (params, { extra, rejectWithValue }) => {
    try { return await extra.KPIService.TimeSeries.productionByProduct(params); }
    catch (err) { return rejectWithValue(err?.response?.data || err.message); }
  }
);

export const readTimeThunk = createAsyncThunk(
  'kpi/timeseries/readTime',
  async (params, { extra, rejectWithValue }) => {
    try { return await extra.KPIService.TimeSeries.readTime(params); }
    catch (err) { return rejectWithValue(err?.response?.data || err.message); }
  }
);
export const materialStockPriceThunk = createAsyncThunk(
  'kpi/timeseries/materialStockPrice',
  async (params, { extra, rejectWithValue }) => {
    try { return await extra.KPIService.TimeSeries.materialStockPrice(params); }
    catch (err) { return rejectWithValue(err?.response?.data || err.message); }
  }
);
export const operationTimeThunk = createAsyncThunk(
  'kpi/timeseries/operationTime',
  async (params, { extra, rejectWithValue }) => {
    try { return await extra.KPIService.TimeSeries.operationTime(params); }
    catch (err) { return rejectWithValue(err?.response?.data || err.message); }
  }
);
